
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[categoryId]",
      function () {
        return require("private-next-pages/[categoryId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[categoryId]"])
      });
    }
  